import React from 'react';

import DashboardListCard from '../../../../ui/DashboardListCard';
import {
    ParticipantsIcon,
    ActivitiesIcon,
    FundsIcon,
    ImpactCertificatesIcon,
    
    SurveyIcon,
    ScoutingIcon,
    HarvestIcon,
    VolunteerIcon,
    UserAvatarIcon
} from '../../../../assets/icons/DashboardIcons'
import DashboardMetricCard from '../../../../ui/DashboardMetricCard';

import useFetchData from '../../../../hooks/useFetchData';
import { getOverallTabData } from '../../../../apis/impact-report/report';
import Loader from '../../../../ui/Loader';
import { bountyTypesWithIconData, bountyTypesWithIconDataRef } from '../../../../constants/datas';
import { useSearchParams } from 'react-router-dom';
import { formatNumber } from '../../../../helpers/formatNumber';


const OverallTab = ({projectId,imageGenerationTimestamp}) => {
const { loading, response, error } = useFetchData(getOverallTabData,[projectId,imageGenerationTimestamp],[projectId,imageGenerationTimestamp]);

console.log("Overall Tab Data:", { loading, response, error },"ye render karna h ");

    // Sample data for the Overall tab
    const overallData = {
        metrics: [
            { title: 'Participants till date', value: response?.uniqueBountyAcceptorCount
, icon: ParticipantsIcon },
            { title: 'Activities completed', value: response?.
completedBountyCount, icon: ActivitiesIcon },
            { title: 'Funds Deployed', value: `$${ formatNumber(response?.totalFundsDeployedUSD) || 0}`, icon: "" },
            { title: 'Impact Certificates Issued', value: response?.totalImpactCertificatesIssued, icon: ImpactCertificatesIcon }
        ],
        topActivitiesWithFunds: response?.mostRewardingBounties?.map(activity=> ({
            title: activity.title,
            value: `$${formatNumber(activity.rewardedAmountUSD)}`,
            key: activity._id
        })) ,
        topActivitiesWithEngagement:response?.mostAcceptedBounties?.map(bounty=>({
               title: bounty?.title,
            value: `${bounty?.uniqueAcceptorCount}`,
            key: bounty?._id
        })) ,
        topActivityTypes: response?.mostUsedBountyTypes?.map(activityType=>
        {
            const Icon = bountyTypesWithIconDataRef?.find(type=>type.label === activityType?.type)?.icon
            return {
            title: activityType?.type,
            value: activityType?.bountyCount,
            icon: <Icon className="w-5 h-5" fillColor="#23522A" /> 
    }}),
        topParticipants:response?.mostActiveUsers?.map(user=>
        {
            return {
                key:user?.uid,
                title: user?.username ||  "Unknown User",
                subtitle: `${user?.bountyCompletionCount || 0} ${user?.bountyCompletionCount>1?"submissions":"submission"}`,
                value: `${user?.totalImpactPoints || 0} IP`,
                icon: <UserAvatarIcon className="w-5 h-5 text-gray-400" />      
        }
        
    })
    }
    console.log(overallData,response,projectId,"overallData")
    return (
            loading ? <div className='w-full h-[39.6875rem] flex pt-11 justify-center '  ><Loader/></div> :
        <div className="space-y-4">


            {/* Top Row - Metric Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {overallData.metrics.map((metric, index) => (
                    <DashboardMetricCard
                        key={index}
                        title={metric.title ||"-"}
                        value={metric?.value ? metric?.value: 0}
                        icon={metric.icon}
                        valueClassName='flex items-center gap-2'
                    />
                ))}
            </div>

            {/* Middle Row - Top Activities Lists */}
            <div className="grid min-h-[15.2rem] grid-cols-1 lg:grid-cols-2 gap-y-4 gap-x-3">
                <DashboardListCard
                    titles={[`Top ${overallData.topActivitiesWithFunds?.length<5?"":"5"} Activities with most funds deployed`]}
                    items={overallData.topActivitiesWithFunds}
                    columnCount={2}
                />
                <DashboardListCard
                    titles={[`Top ${overallData.topActivitiesWithEngagement?.length<5?"":"5"} Activities with most engagement`,"Participants"]}
                    items={overallData.topActivitiesWithEngagement}
                    columnCount={2}
                />
            </div>

            {/* Bottom Row - Top Types and Participants Lists */}
            <div className="grid min-h-[15.2rem]  grid-cols-1 lg:grid-cols-2 gap-y-4 gap-x-3">
                <DashboardListCard
                    titles={[`Top ${overallData.topActivityTypes?.length<5?"":"5"} Activity Types`, "No. of Activities"]}
                    items={overallData.topActivityTypes}
                    columnCount={2}
                />
                <DashboardListCard
                    titles={[`Top ${overallData.topParticipants?.length<5?"":"5"} participants`]}
                    items={overallData.topParticipants}
                    columnCount={3}
                />
            </div>
        </div>
    
    );
};

export default OverallTab; 